import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Sparkles, Clock, ShieldCheck } from 'lucide-react';
interface LandingHeroProps {
  onStart: () => void;
}
export function LandingHero({
  onStart
}: LandingHeroProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.6
  }} className="max-w-3xl mx-auto text-center px-4 py-12 md:py-20" data-id="element-17">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cream-200 text-burgundy-700 text-sm font-medium mb-8" data-id="element-18">
        <Sparkles className="w-4 h-4 text-gold-500" data-id="element-19" />
        <span data-id="element-20">Test de Dermocosmética Avanzada</span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium leading-tight mb-6 text-burgundy-800" data-id="element-21">
        Calculadora de Edad Muscular Facial
      </h1>

      <h2 className="text-xl md:text-2xl text-burgundy-600/80 font-serif italic mb-8" data-id="element-22">
        ¿Tu musculatura facial está envejeciendo más rápido que tu piel?
      </h2>

      <div className="bg-white/60 backdrop-blur-sm rounded-3xl p-8 md:p-10 shadow-premium border border-cream-200 mb-10 text-left relative overflow-hidden" data-id="element-23">
        <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-gold-400 to-burgundy-500" data-id="element-24"></div>
        <p className="text-lg md:text-xl leading-relaxed text-slate-700" data-id="element-25">
          La mayoría de las mujeres tratan sus arrugas con cremas, pero ignoran
          que el{' '}
          <strong className="text-burgundy-700 font-semibold" data-id="element-26">
            80% de la caída facial
          </strong>{' '}
          se debe a la atrofia de los 57 músculos del rostro.
        </p>
        <p className="text-lg md:text-xl leading-relaxed text-slate-700 mt-4" data-id="element-27">
          Realiza este test para descubrir tu nivel de flacidez muscular y
          recibe un protocolo personalizado.
        </p>
      </div>

      <div className="flex flex-col items-center gap-6" data-id="element-28">
        <Button onClick={onStart} showArrow className="text-xl px-10 py-5" data-id="element-29">
          Comenzar Test Gratuito
        </Button>

        <div className="flex items-center justify-center gap-6 text-sm text-slate-500 font-medium" data-id="element-30">
          <div className="flex items-center gap-1.5" data-id="element-31">
            <Clock className="w-4 h-4" data-id="element-32" />
            <span data-id="element-33">Toma solo 30 segundos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-34">
            <ShieldCheck className="w-4 h-4" data-id="element-35" />
            <span data-id="element-36">100% Confidencial</span>
          </div>
        </div>
      </div>
    </motion.div>;
}